// client/src/components/Admin/PlanesEducaCmp/_shared/PlanFiltersBar.js
//
// M07 - Barra de filtros client-side de la pagina Planes:
// busqueda libre (titulo + descripcion + modelo) + select por tipo de cuenta.

import React from "react";
import { Input, Select } from "antd";
import styles from "./PlanFiltersBar.module.scss";

export const ACCOUNT_FILTER_OPTIONS = [
  { value: "all", label: "Todos los tipos" },
  { value: "free", label: "Free" },
  { value: "premium", label: "Premium" },
  { value: "promocion", label: "Promocion" },
];

export function PlanFiltersBar({
  search,
  onSearchChange,
  accountFilter,
  onAccountFilterChange,
}) {
  return (
    <div className={styles.filtersBar}>
      <Input.Search
        className={styles.search}
        placeholder="Buscar por titulo, descripcion o modelo VR"
        allowClear
        value={search}
        onChange={(e) => onSearchChange?.(e.target.value)}
        size="middle"
      />
      <Select
        className={styles.select}
        value={accountFilter}
        onChange={onAccountFilterChange}
        options={ACCOUNT_FILTER_OPTIONS}
        size="middle"
      />
    </div>
  );
}
